import React from 'react'
import { Outlet, useLocation, Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { Menu, X, Shield, Share2, Briefcase } from 'lucide-react'

const Layout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)
  const location = useLocation()

  // 数据看板页不需要导航栏（全屏展示）
  const isDashboard = location.pathname === '/'

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 顶部导航 */}
      {!isDashboard && (
        <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              {/* Logo */}
              <Link to="/" className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">央</span>
                </div>
                <span className="text-lg font-bold text-gray-900 hidden sm:block">
                  央国企求职通
                </span>
              </Link>

              {/* 桌面端导航 */}
              <nav className="hidden md:flex items-center space-x-6">
                <Link to="/" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium">
                  首页
                </Link>
                <Link to="/match" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium">
                  测评
                </Link>
                <Link to="/packages" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium">
                  服务包
                </Link>
                <Link to="/intelligence" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium">
                  情报
                </Link>
                <Link to="/jobs" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium flex items-center">
                  <Briefcase size={14} className="mr-1" />
                  招聘
                </Link>
                <Link to="/share" className="text-gray-600 hover:text-primary-600 transition-colors text-sm font-medium flex items-center">
                  <Share2 size={14} className="mr-1" />
                  分享
                </Link>
              </nav>

              {/* 移动端菜单按钮 */}
              <button
                className="md:hidden p-2 rounded-lg hover:bg-gray-100"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* 移动端菜单 */}
          <AnimatePresence>
            {mobileMenuOpen && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                className="md:hidden bg-white border-t border-gray-200"
              >
                <div className="px-4 py-3 space-y-2">
                  <Link to="/" className="block py-2 text-gray-600 hover:text-primary-600" onClick={() => setMobileMenuOpen(false)}>
                    首页
                  </Link>
                  <Link to="/match" className="block py-2 text-gray-600 hover:text-primary-600" onClick={() => setMobileMenuOpen(false)}>
                    测评
                  </Link>
                  <Link to="/packages" className="block py-2 text-gray-600 hover:text-primary-600" onClick={() => setMobileMenuOpen(false)}>
                    服务包
                  </Link>
                  <Link to="/intelligence" className="block py-2 text-gray-600 hover:text-primary-600" onClick={() => setMobileMenuOpen(false)}>
                    情报
                  </Link>
                  <Link to="/jobs" className="block py-2 text-gray-600 hover:text-primary-600" onClick={() => setMobileMenuOpen(false)}>
                    招聘信息
                  </Link>
                  <Link to="/share" className="block py-2 text-gray-600 hover:text-primary-600" onClick={() => setMobileMenuOpen(false)}>
                    分享赚收益
                  </Link>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </header>
      )}

      {/* 主内容区 */}
      <main className={isDashboard ? '' : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      {/* 底部 */}
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-500">
              © 2026 央国企求职通. 保留所有权利.
            </div>
            <div className="flex items-center space-x-4 text-sm">
              <Link to="/privacy" className="text-gray-500 hover:text-primary-600 flex items-center space-x-1">
                <Shield size={14} />
                <span>隐私政策</span>
              </Link>
              <span className="text-gray-300">|</span>
              <span className="text-gray-500">本系统测评结果仅供参考，不作为录取保证</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Layout
